import React from 'react';

export default function BenefitCard({title, items, image}) {
    return (
        <div className="benefit-card">
            <h3>{title}</h3>
            <p>{items}</p>
            <img src={image} alt={title} />
        </div>
    );
}
